module.exports = __webpack_public_path__ + "static/media/iluma.83565568.png";